import React from "react";
import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";
import { TechValueLockup } from "./HeaderNav";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-slate-950 text-slate-200 overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 tv-hero-dark-grid opacity-40 pointer-events-none" />
      <img
        src="/tech-value-logo.png"
        alt=""
        aria-hidden
        className="absolute -left-14 -bottom-20 w-80 h-80 object-contain opacity-[0.06] pointer-events-none select-none"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <TechValueLockup size="lg" tagline dark />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
            Navi Mumbai&apos;s high-trust doorstep phone buyback & premium refurbished store. Guaranteed spot valuation,
            cash on pickup, zero online advance required.
          </p>
        </div>

        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-400 mb-3 font-bold">Sell With Us</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#brands" className="hover:text-primary">Sell iPhone</a></li>
            <li><a href="/#brands" className="hover:text-primary">Sell Samsung</a></li>
            <li><a href="/#brands" className="hover:text-primary">Sell OnePlus</a></li>
            <li><a href="/#brands" className="hover:text-primary">All Brands</a></li>
            <li><a href="/#how-it-works" className="hover:text-primary">How it Works</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-400 mb-3 font-bold">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/shop" className="hover:text-primary">Refurbished Phones</a></li>
            <li><a href="/track" className="hover:text-primary">Track Order</a></li>
            <li><a href="/credits" className="hover:text-primary">My Credits</a></li>
            <li><a href="/#store" className="hover:text-primary">Store Location</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-400 mb-3 font-bold">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 shrink-0 text-primary" />
              <a href="tel:+918104878405" className="hover:text-primary" data-testid="footer-phone">
                +91 81048 78405
              </a>
              <a
                href="https://wa.me/918104878405"
                target="_blank"
                rel="noreferrer"
                aria-label="Chat on WhatsApp"
                data-testid="footer-whatsapp-link"
                className="ml-1 inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#25D366] hover:bg-[#20BD5A] text-white transition-colors"
              >
                <MessageCircle className="w-3.5 h-3.5" />
              </a>
            </li>
            <li className="flex gap-2"><Clock className="w-4 h-4 mt-0.5 text-primary" /> Mon–Sat · 10:30 AM – 8:00 PM · Sunday Closed</li>
            <li className="flex gap-2 text-slate-300 leading-relaxed">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-primary" />
              <span>
                <span className="font-brand font-bold text-white block text-base">Tech World</span>
                <span className="text-[10px] uppercase tracking-widest text-slate-400 font-mono">Mobile & Laptop Store</span><br/>
                G-189, Funtasiya Business Park,<br/>Plot no. 47, Sector 30A, Vashi,<br/>Navi Mumbai, Maharashtra 400703
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10 py-4 text-center text-xs text-slate-500 font-mono">
        © {new Date().getFullYear()} Tech Value · Apne phone ko dijiye sahi keemat · Powered by Tech World, Navi Mumbai
      </div>
    </footer>
  );
}
